import React from "react";
import SearchIcon from "../../assets/images/SearchIcon";

const SearchBar = ({ from }: any) => {
  const classNameStaff =
    "px-4 lg:w-[272px] md:w-[120px] h-[44px] ps-10 staffListDownloadCheckbox text-sideMenuHelpBox border border-StaffListDownloadCheckboxBorderColor rounded-lg bg-whiteColor cursor-not-allowed";
  const classNameHeader =
    "px-4 lg:w-[520px] lg:w-[120px] h-[48px] ps-10 staffListDownloadCheckbox text-sideMenuHelpBox border border-StaffListDownloadCheckboxBorderColor rounded-lg bg-whiteColor";
  return (
    <div>
      <div className="hidden md:block lg:block  ml-[128px] cursor-not-allowed">
        <div className="relative">
          <div className="absolute inset-y-0 start-0 flex items-center ps-3 ">
            <SearchIcon />
          </div>
          <input
            type="search"
            id="default-search"
            className={from === "Header" ? classNameHeader : classNameStaff}
            placeholder={from === "Header" ? "Search for anything" : "Search"}
            disabled={true}
            required
          />
        </div>
      </div>
    </div>
  );
};
export default SearchBar;
